/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SaveSrvProceedingRequest,
  SrvProceedingListItemResponse,
  SrvProceedingResponse,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SaveSrvProceedingRequestFromJSON,
    SaveSrvProceedingRequestToJSON,
    SrvProceedingListItemResponseFromJSON,
    SrvProceedingListItemResponseToJSON,
    SrvProceedingResponseFromJSON,
    SrvProceedingResponseToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateSrvProceedingRequest {
    clientId: string;
    saveSrvProceedingRequest: SaveSrvProceedingRequest;
}

export interface GetSrvProceedingByIdRequest {
    clientId: string;
    proceedingId: string;
}

export interface GetSrvProceedingsRequest {
    clientId: string;
}

export interface RefreshSrvProceedingClaimsSnapshotRequest {
    clientId: string;
    proceedingId: string;
}

export interface UpdateSrvProceedingRequest {
    clientId: string;
    proceedingId: string;
    saveSrvProceedingRequest: SaveSrvProceedingRequest;
}

/**
 * SrvProceedingApi - interface
 * 
 * @export
 * @interface SrvProceedingApiInterface
 */
export interface SrvProceedingApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {SaveSrvProceedingRequest} saveSrvProceedingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrvProceedingApiInterface
     */
    createSrvProceedingRaw(requestParameters: CreateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>>;

    /**
     */
    createSrvProceeding(requestParameters: CreateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} proceedingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrvProceedingApiInterface
     */
    getSrvProceedingByIdRaw(requestParameters: GetSrvProceedingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>>;

    /**
     */
    getSrvProceedingById(requestParameters: GetSrvProceedingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrvProceedingApiInterface
     */
    getSrvProceedingsRaw(requestParameters: GetSrvProceedingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SrvProceedingListItemResponse>>>;

    /**
     */
    getSrvProceedings(requestParameters: GetSrvProceedingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SrvProceedingListItemResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} proceedingId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrvProceedingApiInterface
     */
    refreshSrvProceedingClaimsSnapshotRaw(requestParameters: RefreshSrvProceedingClaimsSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>>;

    /**
     */
    refreshSrvProceedingClaimsSnapshot(requestParameters: RefreshSrvProceedingClaimsSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} proceedingId 
     * @param {SaveSrvProceedingRequest} saveSrvProceedingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SrvProceedingApiInterface
     */
    updateSrvProceedingRaw(requestParameters: UpdateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>>;

    /**
     */
    updateSrvProceeding(requestParameters: UpdateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse>;

}

/**
 * 
 */
export class SrvProceedingApi extends runtime.BaseAPI implements SrvProceedingApiInterface {

    /**
     */
    async createSrvProceedingRaw(requestParameters: CreateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createSrvProceeding().'
            );
        }

        if (requestParameters['saveSrvProceedingRequest'] == null) {
            throw new runtime.RequiredError(
                'saveSrvProceedingRequest',
                'Required parameter "saveSrvProceedingRequest" was null or undefined when calling createSrvProceeding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/srv-proceedings`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveSrvProceedingRequestToJSON(requestParameters['saveSrvProceedingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SrvProceedingResponseFromJSON(jsonValue));
    }

    /**
     */
    async createSrvProceeding(requestParameters: CreateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse> {
        const response = await this.createSrvProceedingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSrvProceedingByIdRaw(requestParameters: GetSrvProceedingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getSrvProceedingById().'
            );
        }

        if (requestParameters['proceedingId'] == null) {
            throw new runtime.RequiredError(
                'proceedingId',
                'Required parameter "proceedingId" was null or undefined when calling getSrvProceedingById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/srv-proceedings/{proceedingId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"proceedingId"}}`, encodeURIComponent(String(requestParameters['proceedingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SrvProceedingResponseFromJSON(jsonValue));
    }

    /**
     */
    async getSrvProceedingById(requestParameters: GetSrvProceedingByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse> {
        const response = await this.getSrvProceedingByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSrvProceedingsRaw(requestParameters: GetSrvProceedingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SrvProceedingListItemResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getSrvProceedings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/srv-proceedings`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SrvProceedingListItemResponseFromJSON));
    }

    /**
     */
    async getSrvProceedings(requestParameters: GetSrvProceedingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SrvProceedingListItemResponse>> {
        const response = await this.getSrvProceedingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async refreshSrvProceedingClaimsSnapshotRaw(requestParameters: RefreshSrvProceedingClaimsSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling refreshSrvProceedingClaimsSnapshot().'
            );
        }

        if (requestParameters['proceedingId'] == null) {
            throw new runtime.RequiredError(
                'proceedingId',
                'Required parameter "proceedingId" was null or undefined when calling refreshSrvProceedingClaimsSnapshot().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/srv-proceedings/{proceedingId}/claims-snapshot/refresh`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"proceedingId"}}`, encodeURIComponent(String(requestParameters['proceedingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SrvProceedingResponseFromJSON(jsonValue));
    }

    /**
     */
    async refreshSrvProceedingClaimsSnapshot(requestParameters: RefreshSrvProceedingClaimsSnapshotRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse> {
        const response = await this.refreshSrvProceedingClaimsSnapshotRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateSrvProceedingRaw(requestParameters: UpdateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SrvProceedingResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateSrvProceeding().'
            );
        }

        if (requestParameters['proceedingId'] == null) {
            throw new runtime.RequiredError(
                'proceedingId',
                'Required parameter "proceedingId" was null or undefined when calling updateSrvProceeding().'
            );
        }

        if (requestParameters['saveSrvProceedingRequest'] == null) {
            throw new runtime.RequiredError(
                'saveSrvProceedingRequest',
                'Required parameter "saveSrvProceedingRequest" was null or undefined when calling updateSrvProceeding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/srv-proceedings/{proceedingId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"proceedingId"}}`, encodeURIComponent(String(requestParameters['proceedingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveSrvProceedingRequestToJSON(requestParameters['saveSrvProceedingRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SrvProceedingResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateSrvProceeding(requestParameters: UpdateSrvProceedingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SrvProceedingResponse> {
        const response = await this.updateSrvProceedingRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
